import { useEffect, useMemo, useState } from 'react';

type CountUpNumberProps = {
  value: number;
  durationMs?: number;
  decimals?: number;
  suffix?: string;
  prefix?: string;
  className?: string;
};

export default function CountUpNumber({
  value,
  durationMs = 900,
  decimals = 0,
  suffix = '',
  prefix = '',
  className = '',
}: CountUpNumberProps) {
  const [displayValue, setDisplayValue] = useState(0);

  const safeValue = useMemo(() => (Number.isFinite(value) ? value : 0), [value]);

  useEffect(() => {
    let frameId = 0;
    const start = performance.now();
    const initialValue = displayValue;
    const delta = safeValue - initialValue;

    const tick = (timestamp: number) => {
      const elapsed = timestamp - start;
      const progress = Math.min(elapsed / durationMs, 1);
      // easeOutCubic
      const eased = 1 - Math.pow(1 - progress, 3);
      setDisplayValue(initialValue + delta * eased);
      if (progress < 1) {
        frameId = requestAnimationFrame(tick);
      }
    };

    frameId = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frameId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [safeValue, durationMs]);

  return (
    <span className={className}>
      {prefix}
      {displayValue.toFixed(decimals)}
      {suffix}
    </span>
  );
}

